import React from "react";
import { connect } from "react-redux";
import { Input, Select } from "../Input";
import { Button } from "../Button";
import language from "../../language";
import axios from "axios";
import toastMessage from "../../utils/toastMessage";
import icons from "../../constants/icons";
import { getStorage } from "../../utils/storage";
import {
  getCells,
  getDistricts,
  getProvinces,
  getSectors,
  getVillages,
} from "../../utils/rwanda";
import { hospitals } from "../../constants/categories";
import { fetchProductTypes } from "../../utils/queries/productsType";
import { fetchBloodBanks } from "../../utils/queries/bloodBank";
import hospitalQuery from "../../utils/queries/hospitalQuery";
import { defineRole } from "../../utils/handleAccessRoles";
import { ROLE_HOSPITAL } from "../../constants/ROLES";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;
class NewHospital extends React.Component {
  state = {
    name: "",
    error: {},
    isSubmitting: false,
    type: hospitals(this.props.defaultLanguage)[0],
    code: "",
    products: [],
    user: {},
    showCreateBloodBank: false,
    newBloodBankCode: "",
    newBloodBankName: "",
    newBloodBankEmail: "",
    newBloodBankPhone: "",
    newBloodBankHospital: null,
    isCreatingBloodBank: false,
  
    allowedBloodBank: null,
    allowedProducts: null,
    bloodBank: null,
    cell: null,
    district: null,
    multipleAllowedBloodBank: null,
    province: null,
    sector: null,
    village: null,
};

  componentDidMount = async () => {
    const user = await getStorage();
    this.setState({ ...this.props, user });

    if (this.props._id && this.props._id !== "") {
      this.setState({
        province: {
          label: this.props?.address?.province,
          value: this.props?.address?.province,
        },
        district: {
          label: this.props?.address?.district,
          value: this.props?.address?.district,
        },
        sector: {
          label: this.props?.address?.sector,
          value: this.props?.address?.sector,
        },
        cell: {
          label: this.props?.address?.cell,
          value: this.props?.address?.cell,
        },
        village: {
          label: this.props?.address?.village,
          value: this.props?.address?.village,
        },
        type: {
          label: this.props?.type,
          value: this.props?.type,
        },
        allowedBloodBank: {
          label: this.props?.allowedBloodBank?.name,
          value: this.props?.allowedBloodBank?._id,
        },
        allowedProducts: this.props.allowedProducts
          ? this.props.allowedProducts?.map((el) => {
              return {
                label: el.name,
                value: el._id,
              };
            })
          : null,
          multipleAllowedBloodBank: this.props.multipleAllowedBloodBank
          ? this.props.multipleAllowedBloodBank?.map((el) => {
              return {
                label: el.name,
                value: el._id,
              };
            })
          : null,
        bloodBank: this.props.bloodBank
          ? {
              label: this.props.bloodBank.name,
              value: this.props.bloodBank._id,
            }
          : null,
      });
    }
  };

  onChangeText(field, e) {
    let { error } = this.state;
    delete error[field];

    this.setState({
      [field]: e && e?.target ? e?.target?.value : e,
      error,
    });
  }

  validateForm() {
    let { name, error, allowedBloodBank, code } = this.state;

    if (code === "") {
      error.code = language[this.props.defaultLanguage].code_required;
    }

    if (name === "") {
      error.name = language[this.props.defaultLanguage].hospital_name_required;
    }

    if (!allowedBloodBank) {
      error.allowedBloodBank =
        language[this.props.defaultLanguage].allowed_blood_bank_required;
    }
    // if (!district) {
    //   error.district = language[this.props.defaultLanguage].district_required;
    // }

    // if (!sector) {
    //   error.sector = language[this.props.defaultLanguage].sector_required;
    // }

    // if (!village) {
    //   error.village = language[this.props.defaultLanguage].village_required;
    // }

    // if (!cell) {
    //   error.cell = language[this.props.defaultLanguage].cell_required;
    // }

    // if (!province) {
    //   error.province = language[this.props.defaultLanguage].province_required;
    // }

    this.setState({ error });
  }

  getProductTypes = async (isLoading, search = {}) => {
    try {
      this.setState({
        isLoading,
      });

      const data = await fetchProductTypes(this.props.defaultLanguage, {
        inputType: "dropdown",
        ...search,
      });
      this.setState({
        productTypes: data,
        isLoading: false,
      });

      return data;
    } catch (error) {
      this.setState({ isLoading: false });

      toastMessage("error", error);
    }
  };

  getBloodBank = async (isLoadingBloodBank, search = {}) => {
    try {
      this.setState({
        isLoadingBloodBank,
      });

      const data = await fetchBloodBanks(this.props.defaultLanguage, {
        type: "dropdown",
        ...search,
      });
      this.setState({
        bloodBanks: data,
        isLoadingBloodBank: false,
      });

      return data;
    } catch (error) {
      this.setState({ isLoadingBloodBank: false });

      toastMessage("error", error);
    }
  };

  getHospitalsForBB = async (isFetchingHospitalsForBB, search = {}) => {
    try {
      this.setState({ isFetchingHospitalsForBB });
      const data = await hospitalQuery(this.props.defaultLanguage, { type: "dropdown", ...search });
      this.setState({ isFetchingHospitalsForBB: false });
      return data;
    } catch (error) {
      this.setState({ isFetchingHospitalsForBB: false });
    }
  };

  createBloodBank = async () => {
    const { newBloodBankCode, newBloodBankName, newBloodBankEmail, newBloodBankPhone, newBloodBankHospital } = this.state;
    if (!newBloodBankCode || !newBloodBankName) return;

    this.setState({ isCreatingBloodBank: true });
    const user = await getStorage();

    try {
      const { data } = await axios({
        method: "POST",
        url: `${API_URL}/bloodBank`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
        data: {
          code: newBloodBankCode,
          name: newBloodBankName,
          email: newBloodBankEmail,
          phoneNumber: newBloodBankPhone,
          hospital: newBloodBankHospital?.value || null,
        },
      });

      this.setState({
        bloodBank: { label: data.name, value: data._id },
        showCreateBloodBank: false,
        newBloodBankCode: "",
        newBloodBankName: "",
        newBloodBankEmail: "",
        newBloodBankPhone: "",
        newBloodBankHospital: null,
        isCreatingBloodBank: false,
      });

      toastMessage("success", `Blood bank "${data.name}" created successfully`);
    } catch (error) {
      toastMessage("error", error);
      this.setState({ isCreatingBloodBank: false });
    }
  };

  onSubmit = async () => {
    await this.validateForm();

    const {
      error_add_hospital,
      error_update_hospital,
      add_hospital_success,
      update_hospital_success,
    } = language[this.props.defaultLanguage];

    if (Object.keys(this.state.error).length === 0) {
      this.setState({
        isSubmitting: true,
      });

      let {
          name,
          _id,
          province,
          district,
          sector,
          village,
          cell,
          type,
          code,
          allowedProducts,
          allowedBloodBank,
          multipleAllowedBloodBank,
          bloodBank,
        } = this.state,
        url = `${API_URL}/hospital`,
        method = "POST",
        user = await getStorage();

      const _allowedProducts = allowedProducts.map((el) => {
        return el.value;
      });

      let requestBody = {
        name,
        allowedProducts: _allowedProducts.length > 0 ? _allowedProducts : [],
        address: {
          province: province?.value,
          district: district?.value,
          sector: sector?.value,
          cell: cell?.value,
          village: village?.value,
        },
        type: type?.value,
        code,
        allowedBloodBank: allowedBloodBank.value,
        multipleAllowedBloodBank: multipleAllowedBloodBank?.map((el) => el.value),
        bloodBank: bloodBank?.value || null,
      };

      if (_id && _id !== "") {
        method = "PUT";
        requestBody.id = _id;
      }

      const options = {
        method,
        url,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
        data: requestBody,
      };

      axios(options)
        .then((data) => {
          this.setState({
            isSubmitting: false,
          });

          toastMessage(
            "success",
            method === "PUT" ? update_hospital_success : add_hospital_success
          );

          this.props.getData(true);
          this.props.handleCloseModal();
        })
        .catch((error) => {
          toastMessage(
            "error",
            method === "PUT" ? error_update_hospital : error_add_hospital
          );

          this.setState({
            isSubmitting: false,
          });
        });
    }
  };

  render() {
    console.log(this.state.allowedProducts);
    return (
      <div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-12">
              <Input
                leftIcon={icons.code}
                placeholder={
                  language[this.props.defaultLanguage].code_placeholder
                }
                label={language[this.props.defaultLanguage].code}
                required
                value={this.state.code}
                onChange={(e) => this.onChangeText("code", e)}
                error={this.state.error.code}
              />
            </div>
            <div className="col-md-12">
              <Input
                leftIcon={icons.hospitals}
                placeholder={
                  language[this.props.defaultLanguage].name_placeholder
                }
                label={language[this.props.defaultLanguage].name}
                required
                value={this.state.name}
                onChange={(e) => this.onChangeText("name", e)}
                error={this.state.error.name}
              />
            </div>
            <div className="col-md-12">
              <Select
                loadOptions={(e) => this.getProductTypes(true, { q: e })}
                placeholder={language[this.props.defaultLanguage].select}
                label={language[this.props.defaultLanguage].allowed_products}
                required
                value={this.state.allowedProducts}
                onChange={(e) => this.onChangeText("allowedProducts", e)}
                error={this.state.error.allowedProducts}
                isMulti
              />
            </div>
            <div className="col-md-12">
              <Select
                loadOptions={(e) => this.getBloodBank(true, { q: e })}
                placeholder={language[this.props.defaultLanguage].select}
                label={
                  language[this.props.defaultLanguage]
                    .allowed_blood_banks_to_request_from
                }
                required
                value={this.state.allowedBloodBank}
                onChange={(e) => this.onChangeText("allowedBloodBank", e)}
                error={this.state.error.allowedBloodBank}
                isLoading={this.state.isLoadingBloodBank}
              />
            </div>
            <div className="col-md-12">
              <Select
                loadOptions={(e) => this.getBloodBank(true, { q: e }, )}
                placeholder={language[this.props.defaultLanguage].select}
                label={
                  language[this.props.defaultLanguage]
                    .multiple_allowed_blood_banks_to_request_from
                }
                value={this.state.multipleAllowedBloodBank}
                onChange={(e) => this.onChangeText("multipleAllowedBloodBank", e)}
                error={this.state.error.multipleAllowedBloodBank}
                isLoading={this.state.isLoadingBloodBank}
                isMulti
              />
            </div>
            <div className="col-md-12">
              <div className="d-flex align-items-end gap-2">
                <div className="flex-fill">
                  <Select
                    loadOptions={(e) => this.getBloodBank(true, { q: e })}
                    placeholder={language[this.props.defaultLanguage].select}
                    label={language[this.props.defaultLanguage].stock_name}
                    value={this.state.bloodBank}
                    onChange={(e) => this.onChangeText("bloodBank", e)}
                    error={this.state.error.bloodBank}
                    isLoading={this.state.isLoadingBloodBank}
                  />
                </div>
                <Button
                  className="btn-sm btn-default"
                  text="+ New"
                  onPress={() => this.setState((s) => ({ showCreateBloodBank: !s.showCreateBloodBank }))}
                />
              </div>
              {this.state.showCreateBloodBank && (
                <div className="card-body border rounded mt-2">
                  <div className="row">
                    <div className="col-md-6">
                      <Input
                        label={language[this.props.defaultLanguage].code}
                        placeholder={language[this.props.defaultLanguage].code_placeholder}
                        required
                        value={this.state.newBloodBankCode}
                        onChange={(e) => this.setState({ newBloodBankCode: e.target.value })}
                      />
                    </div>
                    <div className="col-md-6">
                      <Input
                        label={language[this.props.defaultLanguage].name}
                        placeholder={language[this.props.defaultLanguage].name_placeholder}
                        required
                        value={this.state.newBloodBankName}
                        onChange={(e) => this.setState({ newBloodBankName: e.target.value })}
                      />
                    </div>
                    <div className="col-md-6">
                      <Input
                        label={language[this.props.defaultLanguage].email_address}
                        placeholder={language[this.props.defaultLanguage].email_placeholder}
                        value={this.state.newBloodBankEmail}
                        onChange={(e) => this.setState({ newBloodBankEmail: e.target.value })}
                      />
                    </div>
                    <div className="col-md-6">
                      <Input
                        label={language[this.props.defaultLanguage].phone_number}
                        placeholder={language[this.props.defaultLanguage].phone_placeholder}
                        value={this.state.newBloodBankPhone}
                        onChange={(e) => this.setState({ newBloodBankPhone: e.target.value })}
                      />
                    </div>
                    <div className="col-md-12">
                      <Select
                        loadOptions={(e) => this.getHospitalsForBB(true, { q: e })}
                        placeholder={language[this.props.defaultLanguage].select}
                        label={language[this.props.defaultLanguage].entity_or_hospital}
                        value={this.state.newBloodBankHospital}
                        onChange={(e) => this.setState({ newBloodBankHospital: e })}
                        isLoading={this.state.isFetchingHospitalsForBB}
                        leftIcon={icons.hospital}
                      />
                    </div>
                  </div>
                  <div className="d-flex justify-content-end gap-2 mt-2">
                    <Button
                      className="btn-sm btn-default"
                      text={language[this.props.defaultLanguage].cancel}
                      onPress={() => this.setState({
                        showCreateBloodBank: false,
                        newBloodBankCode: "",
                        newBloodBankName: "",
                        newBloodBankEmail: "",
                        newBloodBankPhone: "",
                        newBloodBankHospital: null,
                      })}
                    />
                    <Button
                      className="btn-sm"
                      text={language[this.props.defaultLanguage].submit}
                      isSubmitting={this.state.isCreatingBloodBank}
                      onPress={this.createBloodBank}
                    />
                  </div>
                </div>
              )}
            </div>
            <div className="col-md-6">
              <Select
                options={getProvinces(this.state.province)}
                placeholder={language[this.props.defaultLanguage].select}
                label={language[this.props.defaultLanguage].province}
                value={this.state.province}
                onChange={(e) => this.onChangeText("province", e)}
                error={this.state.error.province}
              />
            </div>
            <div className="col-md-6">
              <Select
                options={getDistricts(this.state.province?.value)}
                placeholder={language[this.props.defaultLanguage].select}
                label={language[this.props.defaultLanguage].district}
                value={this.state.district}
                onChange={(e) => this.onChangeText("district", e)}
                error={this.state.error.district}
              />
            </div>
            <div className="col-md-6">
              <Select
                options={getSectors(
                  this.state.province?.value,
                  this.state.district?.value
                )}
                placeholder={language[this.props.defaultLanguage].select}
                label={language[this.props.defaultLanguage].sector}
                value={this.state.sector}
                onChange={(e) => this.onChangeText("sector", e)}
                error={this.state.error.sector}
              />
            </div>
            <div className="col-md-6">
              <Select
                options={getCells(
                  this.state.province?.value,
                  this.state.district?.value,
                  this.state.sector?.value
                )}
                placeholder={language[this.props.defaultLanguage].select}
                label={language[this.props.defaultLanguage].cell}
                value={this.state.cell}
                onChange={(e) => this.onChangeText("cell", e)}
                error={this.state.error.cell}
              />
            </div>
            <div className="col-md-6">
              <Select
                options={getVillages(
                  this.state.province?.value,
                  this.state.district?.value,
                  this.state.sector?.value,
                  this.state.cell?.value
                )}
                placeholder={language[this.props.defaultLanguage].select}
                label={language[this.props.defaultLanguage].village}
                value={this.state.village}
                onChange={(e) => this.onChangeText("village", e)}
                error={this.state.error.village}
              />
            </div>
            <div className="col-md-6">
              <Select
                options={hospitals(this.props.defaultLanguage) || []}
                placeholder={language[this.props.defaultLanguage].select}
                label={language[this.props.defaultLanguage].type}
                value={this.state.type}
                onChange={(e) => this.onChangeText("type", e)}
                error={this.state.error.type}
              />
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <Button
            text={language[this.props.defaultLanguage].cancel}
            onPress={this.props.handleCloseModal}
            className="btn-default"
          />
          {defineRole({
            roles: this.state.user.accessRole,
            menu: ROLE_HOSPITAL,
            operation: "create",
          })}
          <Button
            text={language[this.props.defaultLanguage].submit}
            onPress={this.onSubmit.bind(this)}
            isSubmitting={this.state.isSubmitting}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(NewHospital);
